import { useState } from "react";

import { useStore } from "storev2/formStore";
import { Column, DataTable } from "./table";
import Button from "componentsv2/button/Button";

function PendingSession({ record, onClose, storeId }) {
  const { sessions } = record;
  const [selected, setSelected] = useState(null);
  const { updateRecord, store } = useStore(storeId);

  function handleChange(selected) {
    setSelected(selected);
  }

  function handleAdd() {
    if (!selected) return;

    const newRecord = {
      state: "scheduled",
      id: selected.id,
      number: selected.number,
      product: selected["product."],
      consumer: selected["consumer."],
      sale: selected["sale."],
    };
    updateRecord({
      ...store.record,
      ...newRecord,
    });
    onClose();
  }

  return (
    <div className="m-4">
      <h2 className="text-xl font-bold text-gray-500 m-4">
        Selecciona la sesion a agendar : {selected?.["product."].name}
      </h2>
      <DataTable
        value={sessions}
        selectionMode={"single"}
        selection={selected}
        onSelectionChange={handleChange}
      >
        <Column field="consumer.rec_name" header="Contacto" />
        <Column field="professional.rec_name" header="Profesional" />
        <Column field="product.name" header="Producto" />
        <Column field="sale.rec_name" header="Venta" />
      </DataTable>
      <div className="flex justify-end mt-4">
        <Button
          name={"button.accept"}
          content={"button.accept"}
          onClick={handleAdd}
          color={"blue"}
        />
      </div>
    </div>
  );
}

export default PendingSession;
